// extracted by mini-css-extract-plugin
export default {"tosDiv":"TermsOfService_tosDiv__2hHv8"};